









































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import Announcement from "@/models/annoucement/annoucement.Model";
import { Quill } from "vue-quill-editor";
import { ImageDrop } from "quill-image-drop-module";
import BaseModel from "../../models/base/BaseModel.model";
import Annoucement from "@/models/annoucement/annoucement.Model";
import { Utils } from "@/core/Utils";
import { url } from "inspector";
import AnnoucementResearchArea from "@/models/annoucement/annoucementResearchArea.model";
import moment from "moment";
import TipoEvaluacionService from "@/services/TipoEvaluacion.service";
import TipoEvaluacion from "../../models/evaluacion/tipoEvaluacion.model";
import BaseTreeSelect from "@/components/base/baseTreeSelect/baseTreeSelectCustom.vue";
import { ParesEvaluadoresTypes } from "@/enums/ParesEvaluadoresTypes";
import AnnoucementEvaluationType from "@/models/annoucement/annoucementEvaluationType.Model";
import AnnoucementRequiredEvaluationType from "@/models/annoucement/annoucementRequiredEvaluationType.Model";
import AreaService from '../../services/Area.service';
import AnnoucementService from "@/services/Annoument.service";

@Component({
  components: { BaseTreeSelect },
})
export default class AnnouncementWizard extends GenericAdd<Announcement> {
  currentAnnoucementResearchLine = new AnnoucementResearchArea();
  showWeekNumber = false;
  areaService: AreaService = new AreaService();
  formatAmPm = false;
  enableSeconds = false;
  tipoEvaluacionService: TipoEvaluacionService = new TipoEvaluacionService();
  evaluationTypes: Array<TipoEvaluacion> = [];
  cientificoTecnicoType: ParesEvaluadoresTypes =
    ParesEvaluadoresTypes.CIENTIFICOTECNICO;
  annoucementService = new AnnoucementService();
annoucementPublishes =[];
  mainEvaluationId: number = null;
  areaHistorys = [];
  areaNotHistorys = [];
  evaluacionAEliminar: any = {
    evaluationId: 0,
    requiredEvaluationId: 0,
  };

  constructor() {
    super();
    this.controller = "Annoucements";
    this.model = new Announcement();
    Quill.register("modules/imageDrop", ImageDrop);
  }
  slowReload() {
    
    this.$nextTick().then(() => {
      this.$forceUpdate();
    });
  }
  

  created() {
    this.getAllHistoryArea();
    this.getAllNotHistoryArea();
    let result = this.areaService.GetArea();
    console.log(result);
    this.tipoEvaluacionService.getAll().then((data: TipoEvaluacion[]) => {
      data.forEach((tipoEvaluacion: TipoEvaluacion) => {
        tipoEvaluacion.checkedUI = true;
        tipoEvaluacion.requiredEvaluationTypesUI = [];
        tipoEvaluacion.minimumNumberOfEvaluatorsUI = 1;
      });
      this.evaluationTypes = data;
    });
  }
    getAllHistoryArea(){
      this.areaService.GetHistoryArea().then(response =>{
            this.areaHistorys = response; 
      })
    }
    getAllNotHistoryArea(){
       this.areaService.GetNotHistoryArea().then(response =>{
            this.areaNotHistorys = response; 
      })
    }
  requiredEvaluationValidator(currentEvaluationId, requiredEvaluation) {
    if (requiredEvaluation) {
      let evaluationType = this.evaluationTypes.find(
        (x) => x.id == requiredEvaluation
      );
      if (
        evaluationType.requiredEvaluationTypesUI &&
        evaluationType.requiredEvaluationTypesUI.some(
          (x) => x == currentEvaluationId
        )
      ) {
        return true;
      } else {
        for (
          let i = 0;
          i < evaluationType.requiredEvaluationTypesUI.length;
          i++
        ) {
          const evaluation = evaluationType.requiredEvaluationTypesUI[i];
          let result = this.requiredEvaluationValidator(
            currentEvaluationId,
            evaluation
          );
          if (result) return true;
        }
      }
    }
    return false;
  }

  public onSelectRequiredEvaluations(value, selected, evaluation) {
    let currentEvaluationIsParentOfTheValue = this.evaluationTypes.some(
      (x: any) =>
        x.id == value.id &&
        x.requiredEvaluationTypesUI.find((y) => y == evaluation.id)
    );

    let requiredEvaluationTypes = this.evaluationTypes.find(
      (x) => x.id == value.id
    ).requiredEvaluationTypesUI;
    requiredEvaluationTypes.forEach((requiredEvaluationType) => {
      if (
        this.requiredEvaluationValidator(evaluation.id, requiredEvaluationType)
      ) {
        this.evaluacionAEliminar.evaluationId = evaluation.id;
        this.evaluacionAEliminar.requiredEvaluationId = value.id;
        this.operationNoAllowed(`Operación no permitida`, 5000);
        return;
      }
    });

    if (!currentEvaluationIsParentOfTheValue) {
      this.evaluationTypes.forEach((evaluationType) => {
        if (evaluationType.id == value.id) {
          evaluationType.checkedUI = true;
          evaluationType.disabledUI = true;
        }
      });
    } else {
      if (evaluation && selected) {
        this.evaluacionAEliminar.evaluationId = evaluation.id;
        this.evaluacionAEliminar.requiredEvaluationId = value.id;
        this.operationNoAllowed(
          `Operación no permitida, el ${evaluation.titulo} ya es una evaluación requerida del ${selected.titulo}`,
          10000
        );
      }
    }
  }

  public onDeselectRequiredEvaluations(value) {
    let counter = 0;
    this.evaluationTypes.forEach((evaluationType) => {
      evaluationType.requiredEvaluationTypesUI.forEach(
        (requiredEvaluationTypeUI) => {
          if (value.id == requiredEvaluationTypeUI) counter++;
        }
      );
    });
    if (counter < 2) {
      this.evaluationTypes.forEach((evaluationType) => {
        if (evaluationType.id == value.id) {
          evaluationType.disabledUI = false;
        }
      });
    }
  }
  

  public onComplete() {
    this.model.annoucementEvaluationsTypes = [];
  
    this.evaluationTypes.forEach((evaluationType) => {
      if (evaluationType.checkedUI) {
        let annoucementEvaluationType = new AnnoucementEvaluationType();
        //
        annoucementEvaluationType.isMainEvaluation =
          evaluationType.id === this.mainEvaluationId ? true : false;
        annoucementEvaluationType.evaluationTypeId = evaluationType.id;
        annoucementEvaluationType.evaluationType = null;
        annoucementEvaluationType.minimumNumberOfEvaluators =
          evaluationType.minimumNumberOfEvaluatorsUI;
        //
        evaluationType.requiredEvaluationTypesUI.forEach(
          (requiredEvaluationTypeId) => {
            //
            let annoucementRequiredEvaluationType = new AnnoucementRequiredEvaluationType();
            annoucementRequiredEvaluationType.evaluationTypeId = requiredEvaluationTypeId;
            annoucementEvaluationType.annoucementRequiredEvaluationTypes.push(
              annoucementRequiredEvaluationType
            );
            //
          }
        );
        this.model.annoucementEvaluationsTypes.push(annoucementEvaluationType);
      }
    });
    return this.validate();
  }

  public termConditionSelected(value: BaseModel) {
    this.model.titleTermCondiction = value.title;
    this.model.descriptionTermCondiction = value.description;
  }
  public monthNames = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];
  public dayNames = ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"];
  public formatDateTime(date: string) {
    if (date) return moment(date).format("DD/MM/YYYY HH:mm");
  }
  editorOption = {
    modules: {
      toolbar: [
        ["bold", "italic", "underline"],
        ["blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ size: ["small", false, "large", "huge"] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ font: [] }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ["clean"],
        ["link", "image", "video"],
      ],
      imageDrop: true,
    },
    placeholder: "Escriba el contenido aqui...",
  };

  public convertirAMinuscula(event: any) {
    this.model.key = event.target.value.toLowerCase();
  }

  public deleteCriterio(indice: any) {
    this.model.annoucementAreas.splice(indice, 1);
  }

  addAnnoucementReserachLine() {
    if (this.currentAnnoucementResearchLine.researchLineId) {
      var newObject = Utils.mapToObject(
        this.currentAnnoucementResearchLine,
        new AnnoucementResearchArea()
      ) as AnnoucementResearchArea;
      this.model.annoucementAreas.push(newObject);

      this.currentAnnoucementResearchLine.init();
    } else {
      this.operationFailedErrors(["Debes seleccionar todos los campos"]);
    }
  }
}
